import { Component, useState } from "react";
import { LabelContainer } from "../assets/style";
import { Box, FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import FormLongLabel from "./FormLongLabel";

export default function FormDropDownList(props: { title?: any, sameRowTitle?: any, value?: any, handleValueChange: Function, items: Array<string>, displayEmpty?: boolean }) {
    const { title, sameRowTitle, value, handleValueChange, items, displayEmpty } = props
    const containerStyle = {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
        minWidth: "100px",
        maxWidth: "600px",
    };
    const inputStyle = {
        margin: "10px",
        marginLeft: "20px",
        borderRadius: "6px",
        height: "32px",
        // maxWidth: "250px",
        width: "50%",

    };

    return (
        <div >
            {title && <FormLongLabel title={title} />}
            <Box sx={containerStyle}>
                {
                    sameRowTitle && <LabelContainer style={{ marginLeft: "28px" }}>
                        {sameRowTitle + ": "}
                    </LabelContainer>
                }
                <FormControl sx={inputStyle}>
                    <Select
                        value={value}
                        onChange={(event) => handleValueChange(event)}
                        style={{ marginBottom: "20px", backgroundColor: "white", height: "32px" }}
                        displayEmpty={displayEmpty}
                    >
                        {items?.map((item, index) => (
                            <MenuItem key={index} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
        </div>
    );
}
